import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    id: string,
    title: string,
}

interface Variables {
    input: {
        code: string,
        description: string,
        id: string,
        price: number,
        title: string,
    }
}

export const UPDATE_PACKAGE: TypedDocumentNode<Result, Variables> = gql`
    mutation UpdatePackage($input: UpdatePackageInput){
        updatePackage(input: $input) {
            id
            title
        }
    }       
`
